import {
  PermissionCheckInput,
  usePermissionCheckQuery,
} from "@/src/graphql/generated";
import useGqlClient from "@/src/hooks/useGqlClient";

interface PermissionCheckProps {
  input: PermissionCheckInput;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  disabled?: boolean; // If true, render children who don't have the permission
}

export function PermissionCheck({
  input,
  children,
  disabled = false,
  fallback,
}: PermissionCheckProps) {
  const client = useGqlClient();
  const permissionCheckQuery = usePermissionCheckQuery(client, {
    input: input,
  });

  if (
    permissionCheckQuery.isLoading ||
    !permissionCheckQuery.data ||
    permissionCheckQuery.error
  ) {
    return null;
  }

  if (permissionCheckQuery.data.permissionCheck.hasAccess && !disabled) {
    return <>{children}</>;
  }

  // For rendering children who DON'T have a specific permission
  if (!permissionCheckQuery.data.permissionCheck.hasAccess && disabled) {
    return <>{children}</>;
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  return null;
}
